import { useState } from 'react';
import { Button, Form, InputGroup } from 'react-bootstrap';
import { FaEye, FaEyeSlash } from 'react-icons/fa6';

const PasswordInput = ({
  label,
  value,
  onChange,
  backgroundColor = 'var(--color-primary)',
  controlId,
}) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  return (
    <Form.Group controlId={controlId}>
      <Form.Label className="mb-1">{label}</Form.Label>

      <InputGroup>
        <Form.Control
          type={isPasswordVisible ? 'text' : 'password'}
          value={value}
          onChange={(event) => onChange(event.target.value)}
          placeholder="Enter password"
          className="shadow-none border-0"
          style={{
            backgroundColor,
            color: 'var(--color-font)',
            height: 50,
          }}
        />

        <Button
          variant="outline-secondary"
          onClick={() => setIsPasswordVisible((isVisible) => !isVisible)}
          aria-label={isPasswordVisible ? 'Hide password' : 'Show password'}
          aria-pressed={isPasswordVisible}
          className="d-flex align-items-center shadow-none border-0"
          style={{
            backgroundColor,
            color: 'var(--color-font)',
          }}
        >
          {isPasswordVisible ? <FaEyeSlash /> : <FaEye />}
        </Button>
      </InputGroup>
    </Form.Group>
  );
};

export default PasswordInput;
